import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"
import "tom-select/dist/css/tom-select.css"

export default class extends Controller {
  connect() {
    new TomSelect(this.element, {
      create: true, // Allow to create a new item
      createOnBlur: true, // Allow to create a new item on blur
      maxItems: null, // Allow to add multiple items
      plugins: ['remove_button'], // Allow to remove an item
      persist: false, // Don't persist the items
      delimiter: ',', // Allow to add multiple items separated by a comma
    });
  }
}
